import { Button, ButtonGroup, Flex, Heading, ModalDialog, Paragraph, TextButton } from '@zillow/constellation';

type RecuringAvailabilityConfirmationModalProps = {
  isForDelete: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const RecuringAvailabilityConfirmationModal = ({
  isForDelete,
  onClose,
  onConfirm,
}: RecuringAvailabilityConfirmationModalProps) => {
  const action = isForDelete ? 'Delete' : 'Update';
  const body = isForDelete
    ? "Deleting a repeating time frame removes all upcoming availability for that time. If you only want to remove one day's availability, edit your time frame instead."
    : 'Your changes will be applied to all the other days where this time frame repeats.';

  return (
    <ModalDialog
      data-testid="RecuringAvailabilityConfirmationModal"
      isOpen={true}
      onClose={onClose}
      renderBody={
        <Flex display="flex" flexDirection="column" gap="sm" marginBottom="xs">
          <Heading level="4" fontFamily="serif">
            {action} repeating availability
          </Heading>
          <Paragraph>{body}</Paragraph>
        </Flex>
      }
      renderFooter={
        <ButtonGroup aria-label="Modal actions">
          <TextButton onClick={onClose} data-testid="RecuringAvailabilityConfirmationModal-CancelBtn">
            Cancel
          </TextButton>
          <Button
            buttonType="primary"
            onClick={onConfirm}
            data-testid="RecuringAvailabilityConfirmationModal-ConfirmBtn"
          >
            {action}
          </Button>
        </ButtonGroup>
      }
      renderHeader={<Paragraph style={{ minHeight: '24px' }} />}
    />
  );
};

export default RecuringAvailabilityConfirmationModal;
